import classNames from 'classnames';
import Card from '../Card/Card';
import Heading from '../Heading/Heading';
import styles from './pricing.module.scss';
import { Image } from 'src/types/Image';
import HTMLReactParser from 'html-react-parser';
import { Button } from '@get-mosh/msh-shared';
import EventNames from 'src/analytics/EventNames';
import Routes from 'src/constants/Routes';
import common from 'src/data/common.json';
import { Subvertical, Vertical } from 'src/constants/Verticals';
import { EventProps } from 'src/analytics/EventProps';

export interface PricingProps {
    title?: string;
    className?: string;
    bottomContent?: string;
    cards?: PricingCardProps[];
    cta?: PricingCardCtaProps;
}

export type PricingCardCtaProps = {
    label: string;
    url: string;
    trackEventProps?: EventProps;
    trackEvent?: () => void;
    external?: boolean;
};
type PricingCardProps = {
    name: string;
    image: Image;
    list: PricingCardListProps[];
    pricing: PricingCardPriceProps;
    className?: string;
};

type PricingCardListProps = {
    label: string;
    value: string;
};

export type PricingCardPriceProps = {
    prefix?: string;
    value: string;
    frequency?: string;
    frequencyDelimiter?: string;
};
const CardData = {
    image: {
        src: '/images/sex/ed-daily-use-584-406.webp',
        width: 584,
        height: 406,
        alt: 'ed daily use',
    },
    name: 'On-demand',
    subtitle: 'Prescription ED meds',
    pricing: {
        prefix: 'From',
        value: '$5.94',
        frequency: 'dose',
    },
    list: [
        {
            label: 'Doctor consult:',
            value: 'Free',
        },
        {
            label: 'Delivery frequency:',
            value: 'Flexible',
        },
    ],
};

const Pricing = (props: PricingProps) => {
    return (
        <div className={classNames(props.className)}>
            {props.title && <Heading level="h2">{props.title}</Heading>}
            {props.cards && (
                <div className={styles['cards']}>
                    {props.cards.map((e: PricingCardProps, i: number) => (
                        <div className={styles['card-pricing']} key={i}>
                            <CardPricing {...e} />
                        </div>
                    ))}
                </div>
            )}
            <div className={styles['bottom']}>
                {props.bottomContent && HTMLReactParser(props.bottomContent)}
            </div>
            <div className={styles['cta']}>
                {props.cta && (
                    <Button
                        as="a"
                        text={props.cta.label}
                        href={props.cta.url}
                        onClick={props.cta.trackEvent}
                        stretch
                    />
                )}
            </div>
        </div>
    );
};

const CardPricing = (e: PricingCardProps) => {
    return (
        <Card {...e}>
            {e.list && <CardListContent list={e.list} />}
            {e.pricing && <CardPricingContent {...e.pricing} />}
        </Card>
    );
};

type CardListContentProps = {
    list: PricingCardListProps[];
};

const CardListContent = ({ list }: CardListContentProps) => {
    return (
        <ul className={styles['card--list']}>
            {list.map((e: PricingCardListProps, i: number) => (
                <li key={i}>
                    <span className={styles['label']}>{e.label}</span>
                    <span className={styles['value']}>{e.value}</span>
                </li>
            ))}
        </ul>
    );
};

const CardPricingContent = (pricing: PricingCardPriceProps) => {
    return (
        <div className={styles['card--pricing']}>
            {pricing.prefix && (
                <span className={styles['prefix']}>{pricing.prefix} </span>
            )}
            <span className={styles['value']}>{pricing.value}</span>
            {pricing.frequency && (
                <span className={styles['frequency']}>
                    {pricing.frequencyDelimiter || '/'}
                    {pricing.frequency}
                </span>
            )}
        </div>
    );
};

Pricing.defaultProps = {
    title: 'Pricing',
    className: styles['wrapper'],
    cta: {
        label: common.takeTheQuiz,
        url: Routes.SEX_INITIAL_QUIZ,
        trackingEvent: {
            name: EventNames.BUTTON_START_QUIZ,
            eventProps: {
                vertical: Vertical.SEX,
                subvertical: Subvertical.ED,
            },
        },
    },
    bottomContent:
        "<p><b>Why aren't you guys saying the names of what you sell?</b></p><p>Legislation means that we aren't allowed to mention specific drug names.<br/>But if there's a treatment that you know that you want, there's a very good chance we have it.</p>",
    cards: [{ ...CardData }, { ...CardData }],
};

export default Pricing;
